import React, {FC} from 'react';
import StarsOutlined from 'components/ContentPagesComponents/StarsOutlined';
import {COLORS} from 'constants/index';

import * as styles from './styles.module.scss';

export type ReviewBarProps = {
	score: number;
	clients: number;
	color?: string;
}

export const ReviewBar: FC<ReviewBarProps> = ({
	score,
	clients,
	color = COLORS.SALAD100,
}) => {
	const fmtClients = clients?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	const animateAfter = 0.5;

	return (
		<div className={styles.reviews}>
			<div className={styles.stars}>
				<StarsOutlined rating={score} delay={animateAfter} color={color} />
				<span>{score}</span>
				<div className={styles.clients}>Over {fmtClients} clients</div>
			</div>
		</div>
	);
};
